/* Order limit. Blocks adding more than settings.max_per_customer cables to one bag.

   This is a deterrent, not enforcement: a shopper can still place a second order,
   and anything that bypasses the storefront (a direct /cart/add POST) is unaffected.
   Enforcing a real per-customer limit needs a cart validation function or an app. */
(function () {
  'use strict';

  var cfg = window.keburuLimits || {};
  var MAX = parseInt(cfg.maxPerCustomer, 10);
  if (!MAX || MAX < 1) return;

  var R = (window.keburu && window.keburu.routes) || { cart: '/cart.js' };

  function countInBag() {
    return fetch(R.cart, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { return c.item_count || 0; })
      .catch(function () { return 0; });
  }

  function say(msg) {
    var status = document.querySelector('[data-status]');
    if (status) status.textContent = msg;
  }

  /* Capture phase on the document runs before the form's own listener, so the add
     can be stopped before keburu.js posts it. Once the count checks out, the form is
     resubmitted with a flag so this handler lets it straight through. */
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('[data-buy-form]') : null;
    if (!form) return;

    if (form.getAttribute('data-limit-ok') === '1') {
      form.removeAttribute('data-limit-ok');
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    var qtyInput = form.querySelector('[data-qty-input]');
    var want = parseInt(qtyInput && qtyInput.value, 10) || 1;

    countInBag().then(function (have) {
      if (have + want > MAX) {
        var left = Math.max(0, MAX - have);
        say(left
          ? 'LIMIT OF ' + MAX + ' CABLES PER ORDER. YOU CAN ADD ' + left + ' MORE.'
          : 'YOU HAVE REACHED THE LIMIT OF ' + MAX + ' CABLES PER ORDER.');
        return;
      }
      form.setAttribute('data-limit-ok', '1');
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }, true);
})();
